<template>
    <div id="echarts-main" class="echarts-main" :style="myStyle()">

    </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    name: "echarts",
    data() {
        return {
            myChart: null
        }
    },
    props: {
        height: {
            type: String,
            default: '350'
        },
        /* 标题 */
        title: {
            type: [String, Object],
            default: ''
        },
        tooltip: {
            type: Object,
            default: {
                // trigger: 'axis',
                // axisPointer: {
                //     type: 'cross',
                //     label: {
                //         backgroundColor: '#6a7985'
                //     }
                // }
            },
        },
        grid: {
            type: Object,
            default: () => {
                return {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                }
            },
        },
        //图例选项
        legend: {
            type: Object,
            default: () => {
                return {
                    data: ['今日订单', '今日交易', '新增会员', '今日充值']
                }
            },
        },
        //横向列数据
        xAxis: {
            type: Object,
            default: () => {
                return {
                    data: ['05-26', '05-27', '05-28', '05-29', '05-30', '05-31']
                }
            },
        },
        //纵向列数据
        yAxis: {
            type: Object,
            default: {},
        },
        //实际显示数据
        series: {
            type: Array,
            default: () => {
                return [{
                    name: '销量',
                    type: 'bar',
                    data: [5, 20, 36, 10, 10, 20]
                }]
            },
        },
    },
    mounted() {
        //初始化 基于准备好的dom，初始化echarts实例
        this.myChart = echarts.init(document.getElementById('echarts-main'));
        this.init(this)
    },
    methods: {
        myStyle() {
            let height = 'number' == typeof this.height ? height + 'px' : this.height;
            return 'width: 100%;height:' + height + 'px;';
        },
        init(obj) {
            //设置渲染数据
            this.$nextTick(() => {
                this.myChart.setOption({
                    title: 'object' === typeof obj.title ? obj.title : {
                        text: obj.title ? obj.title : '未知'
                    },
                    tooltip: obj.tooltip ? obj.tooltip : {
                        // trigger: 'axis',
                        // axisPointer: {
                        //     type: 'cross',
                        //     label: {
                        //         backgroundColor: '#6a7985'
                        //     }
                        // }
                    },
                    legend: obj.legend ? obj.legend : {
                        data: []
                    },
                    xAxis: obj.xAxis ? obj.xAxis : [],
                    yAxis: obj.yAxis ? obj.yAxis : [],
                    series: obj.series ? obj.series : []
                });
                this.myChart.resize()
            });
        }
    },
    watch: {

    },
};
</script>

<style scoped>
.echarts-main {
    width: 100%;
    height: 350px;
}
</style>



// WEBPACK FOOTER //
// src/components/Echarts/index.vue